import React from "react";
import FfairModal from "view/components/modal/FfairModal";
import FlexBox from "view/components/Layout/FlexBox";
import FfairPaper from "view/components/FfairPaper";
import {Button, Typography} from "@material-ui/core";
import {useTaskTimeline} from "hooks";
import {T, useTranslate} from "@tolgee/react";

import {IShow} from "@evennt-tech/api-v2-core";
import useStyles from "./styles";

type ModalProps = {
  onClose: () => void;
  taskId: string;
  standId: string;
  show: IShow;
};

function Modal({onClose, taskId, standId, show}: ModalProps) {
  const classes = useStyles();
  const {t} = useTranslate();

  const [timelineView, loading] = useTaskTimeline({
    show,
    standId,
    taskId,
  });

  if (loading) {
    return null;
  }

  return (
    <FfairModal open onClose={onClose}>
      <FfairPaper className={classes.root}>
        <Typography className={classes.modalSubtitle}>
          <T keyName="common.tasks.history.modal_subtitle" />
        </Typography>
        <Typography className={classes.modalTitle}>
          <T keyName="common.tasks.history.modal_title" />
        </Typography>
        <FlexBox column gap={3} marginTop={3}>
          {timelineView}
        </FlexBox>
        <FlexBox justifyContent="flex-end">
          <Button
            onClick={onClose}
            color="primary"
            className={classes.closeButton}
          >
            {t("common.tasks.history.close_caps")}
          </Button>
        </FlexBox>
      </FfairPaper>
    </FfairModal>
  );
}

export default Modal;
